import * as Yup from 'yup';

export default action =>
  action === 'Add'
    ? Yup.object().shape({
        season: Yup.object().test(
          'season-required',
          'Crop Season is required',
          value => value?.id && value?.name
        ),
        crop: Yup.object().test(
          'crop-required',
          'Crop is required',
          value => value?.id && value?.name
        )
      })
    : Yup.object().shape({
        crop: Yup.object().test(
          'crop-required',
          'Crop is required',
          value => value?.id && value?.name
        )
      });
